export const AUTH_REDIRECT_ERROR_KEY = 'error' as const;
export const AUTH_REDIRECT_ERROR_DESCRIPTION_KEY = 'error_description' as const;

export const AUTH_INVITATION_CODE_KEY = 'invitationCode' as const;
